module.exports = __webpack_public_path__ + "static/img/c44023c.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/xczx/img/swipe_01.png
// module id = 700
// module chunks = 2